import { switchMap } from 'rxjs/operators'

import expirationTimeRefresh$ from '@apiEnabler/ob-common/lib/expiration-time-refresh'
import { isStaffMember$ } from './staff'

const expirationTimeRefreshPbb$ = isStaffMember$.pipe(
  switchMap(isStaffMember =>
    expirationTimeRefresh$(isStaffMember ? 'employee' : 'ping')
  )
)

export default expirationTimeRefreshPbb$
